export default "__VITE_ASSET__C1F$9zXH__"